import { render, staticRenderFns } from "./SafariWarning.vue?vue&type=template&id=5b6e9332&scoped=true"
import script from "./SafariWarning.vue?vue&type=script&lang=js"
export * from "./SafariWarning.vue?vue&type=script&lang=js"
import style0 from "./SafariWarning.vue?vue&type=style&index=0&id=5b6e9332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6e9332",
  null
  
)

export default component.exports